// 导出该模块（云桌面管理）state、actions、mutations
import actions from './actions'
import productStrategyMng from './metaData/strategyForm'
export default {
  state: productStrategyMng,
  actions
}
